import {
  calDiscount,
  getLocalPrice,
  getPrice,
  TradeDataConverter,
} from "functions/src/shared";
import { PurchaseHistoryData } from "functions/src/shared/Digital/User/PurchaseHistoryData";
import XLSX from "xlsx";
import { get_i18n_Country } from "../../Country/i18nCountry";
//匯出報表要做那些功能?
//要把已退款分開來處理?? 扣除memo

//統計所有品項??
//要能知道bundle?
function hashStr(str: string) {
  var hash = 0;
  for (var i = 0; i < str.length; i++) {
    var character = str.charCodeAt(i);
    hash = (hash << 5) - hash + character;
    hash = hash & hash; // Convert to 32bit integer
  }

  return Math.abs(hash); // hash;
}

export async function exportTransactions(
  purchase_records: PurchaseHistoryData[],
  between: {
    startDate: string;
    endDate: string;
  }
) {
  const currencyList: ("TWD" | "USD")[] = ["TWD", "USD"];

  //currency先分一類
  for (var i = 0; i < 2; i++) {
    const currency = currencyList[i];
    // const startTime = new Date(between.startDate).getTime();
    // const endTime = new Date(between.endDate).getTime();
    const timeRange = between.startDate + "_" + between.endDate;
    console.log("Time Range", timeRange);

    const aoa: Array<Array<string | number>> = [];
    const aoa_all: Array<Array<string | number>> = [];
    // all 分頁逐項拆分：每列尾端依序追加各商品的「名稱、價格」。
    // maxItems 記錄所有交易中最多的商品數，最後用來動態產生表頭欄位。
    var maxItems = 0;

    aoa.push([
      "Bundle",
      "Product ID",
      "Game",
      "Country Code", //"國家",
      "Country Name",
      "Currency", //幣別",
      "Base Price", //"單價",
      "Discount", //"折扣",
      "Gross Units Sold", //"總銷售數量",
      "Units Returns", //"總退貨數量",
      "Net Units Sold", //"淨銷售數量",
      "Sale Unit Price", //"銷售單價",
      "Gross Sales", //"總銷售金額",
      "Sales Returns", //"總退貨金額",
      "Net Sales", //"淨銷售淨額",
    ]);

    //分country：看有哪些國家
    var countryDict: { [country: string]: PurchaseHistoryData[] } = {};
    for (var record of purchase_records) {
      if (record.paymentInfo.currency == currency && record.type != "fail") {
        if (record.campaign_slug != null) {
          continue;
        }
        const country = record.paymentInfo.billing.country;
        if (countryDict[country] == null) countryDict[country] = [];
        countryDict[country].push(record);
      }
    }

    //跑每個國家
    for (var country in countryDict) {
      const records = countryDict[country];
      var summaryDict: {
        [bundle_pid: string]: {
          discount: number;
          oriPrice: number;
          discountPrice: number;
          title: string;
          pid: string;
          saleCountAll: number;
          refundCountAll: number;
        };
      } = {};
      for (var record of records) {
        var productSummary = "";

        //FIXME: 買bundle應該要帶入bundle的slug 到 record.slug
        var bunldeSnapshotID =
          record.paymentInfo.title + record.paymentInfo.totalAmount;

        if (record.paymentInfo.currency == currency && record.type != "fail") {
          for (var index in record.paymentInfo.products) {
            productSummary += record.paymentInfo.products[index].pid;
            var product = record.paymentInfo.products[index];

            //做一次mapping，以後應該可以用slug，還沒deploy (2/25)

            var packageTitle = record.paymentInfo.title; //會有語言差異，不好
            //單一品項
            if (record.paymentInfo.products.length == 1) {
              packageTitle = "Direct sale";
            } else {
              packageTitle = "Bundle";
            }

            //
            // const title_pid = packageTitle +  "_" + product.pid;
            const title_pid =
              packageTitle + "_" + bunldeSnapshotID + "_" + product.pid;

            //lazy初始化
            if (summaryDict[title_pid] == null) {
              var discountP = record.paymentInfo.discountPercent; //ex: 20 off
              if (Number.isNaN(discountP)) {
                discountP = 0;
              }
              //反推？沒有寄到根本悲劇?
              var ratio = (100 - discountP) / 100;
              var oriPrice = product.priceData.price / ratio; //FIXME: 會有誤差嗎？

              summaryDict[title_pid] = {
                title: title_pid,
                oriPrice: oriPrice,
                discount: discountP,
                discountPrice: product.priceData.price,
                pid: product.pid,
                saleCountAll: 0,
                refundCountAll: 0,
              };
            }

            //銷售
            if (record.type == "purchase")
              summaryDict[title_pid].saleCountAll++;
            //退款
            if (record.type == "refund") {
              summaryDict[title_pid].refundCountAll++;
            }
          }
        }

        // 逐項拆分：依序追加各商品的 ID 與價格（退款比照 Final Price 取負）
        // 用 pid 而非 title，避免名稱因語言不同而改變
        const products = record.paymentInfo.products ?? [];
        const sign = record.type == "purchase" ? 1 : -1;
        const itemCells: (string | number)[] = [];
        for (var p of products) {
          itemCells.push(p.pid, sign * (p.priceData?.price ?? 0));
        }
        if (products.length > maxItems) {
          maxItems = products.length;
        }

        aoa_all.push([
          record.id,
          record.paymentInfo.title,
          productSummary,
          // product.pid,
          // product.title,
          country,
          get_i18n_Country("en-US", country),
          currency,
          record.type == "purchase"
            ? record.paymentInfo.totalAmount
            : -record.paymentInfo.totalAmount,
          record.paymentInfo.discountPercent,
          // summaryDict[title_pid].oriPrice,
          // summaryDict[title_pid].discount,
          ...itemCells,
        ]);
      }

      //summary 報表
      for (var c_id in summaryDict) {
        const summary = summaryDict[c_id];
        // var price = await getPrice(summary.pid)
        // calDiscount(price[currency].price,currency,summary.discount)

        const saleAmountAll = summary.saleCountAll * summary.discountPrice;
        const returnAmountAll = summary.refundCountAll * summary.discountPrice;
        var finalTitle = summary.title;
        //TODO: hashed pid
        hashStr(summary.pid).toString();
        aoa.push([
          // c_id,
          finalTitle, //Bundle or Direct Sale
          summary.pid, //product id
          summary.pid.split("_")[0], //TODO:很髒 belong to what game...
          country, //country code
          get_i18n_Country("en-US", country), //country text
          currency,
          summary.oriPrice,
          summary.discount,
          summary.saleCountAll,
          summary.refundCountAll,
          summary.saleCountAll - summary.refundCountAll,
          summary.discountPrice,
          saleAmountAll,
          returnAmountAll,
          saleAmountAll - returnAmountAll,
        ]);
      }
    }

    // 依最多商品數動態補上逐項欄位表頭（商品1名稱/商品1價格…），插到第一列
    const allHeader: (string | number)[] = [
      "purchase_id",
      "Bundle",
      "Product IDs",
      "Country Code", //"國家",
      "Country Name",
      "Currency", //幣別",
      "Fianl Price", //"單價",
      "Discount", //"折扣",
    ];
    for (var n = 1; n <= maxItems; n++) {
      allHeader.push("商品" + n + "ID", "商品" + n + "價格");
    }
    aoa_all.unshift(allHeader);

    const ws_all = XLSX.utils.aoa_to_sheet(aoa_all);

    const ws = XLSX.utils.aoa_to_sheet(aoa);

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "main");
    XLSX.utils.book_append_sheet(wb, ws_all, "all");

    //TODO:輸出XLSX?
    const csv = XLSX.utils.sheet_to_csv(ws);
    // XLSX.writeFile(wb, "電子發票開立報表.xlsx");
    XLSX.writeFile(wb, timeRange + "_" + currency + ".xlsx");
    // var element = document.createElement("a");
    // element.href = "data:application/octet-stream," + csv;
    // // <a href="data:application/octet-stream,field1%2Cfield2%0Afoo%2Cbar%0Agoo%2Cgai%0A">CSV Octet</a>
    // element.setAttribute("download", timeRange + "帳務.csv");
    // document.body.appendChild(element);
    // element.click();
    // document.body.removeChild(element);
  }
}
